<div class="application-menu-list-container" [@transformPanel]="'showing'">
  <h3>{{ 'label.Applications.ChooseApplication' | translate }}</h3>

  <iris-application-switcher [displayMode]="'menu'"></iris-application-switcher>
</div>
